import * as React from 'react'
import * as moment from 'moment'
import { IRiderActivityLocationObject } from '../../../../types'

interface ILocationItemState {
  hover: boolean
}

export interface ILocationListItemProps {
  locationActivity: IRiderActivityLocationObject
}

class LocationActivityListItem extends React.Component<ILocationListItemProps, ILocationItemState> {
  constructor(props: ILocationListItemProps) {
    super(props)
    this.state = {
      hover: false
    }
  }

  public render() {
    const { locationActivity } = this.props
    if (!locationActivity) {
      return null
    }

    const addressParts = locationActivity.location.fullAddress.split(',')
    const shortAddress = addressParts[0] + ', ' + addressParts[1]

    return (
      <div
        className={`flex ${this.state.hover && 'bg-light-grey2'} px1`}
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
      >
        <div className='col-2'>
          <span className='h5'>{locationActivity.location.placeName}</span>
        </div>
        <div className='col-4'>
          {/* TODO: Add map widget & icon */}
          <span className='h5'>{shortAddress}</span>
        </div>
        <div className='col-2'>
          <span className='h5'>{locationActivity.location.note}</span>
        </div>
        <div className='col-2'>
          <span className='h5'>
            {locationActivity.createdAt ? moment(locationActivity.createdAt).format('M/D/YYYY hh:mmA') : '-'}
          </span>
        </div>
        <div className='col-2'>
          <span className='h5'>
            {locationActivity.updatedAt ? moment(locationActivity.updatedAt).format('M/D/YYYY hh:mmA') : '-'}
          </span>
        </div>
        <div className='col-2'>
          <span className='h5'>
            {locationActivity.deletedAt ? moment(locationActivity.deletedAt).format('M/D/YYYY hh:mmA') : '-'}
          </span>
        </div>
        <div className='col-2'>
          <span className='h5'>{locationActivity.by.firstName + ' ' + locationActivity.by.lastName}</span>
        </div>
        <div className='col-2'>
          <span className='h5 font-grey2'>{locationActivity.before ? locationActivity.before : '-'}</span>
        </div>
        <div className='col-2'>
          <span className='h5 font-grey2'>{locationActivity.after ? locationActivity.after : '-'}</span>
        </div>
        <div className='col-2'>
          <span className='h5 font-grey2'>{locationActivity.fieldUpdated ? locationActivity.fieldUpdated : '-'}</span>
        </div>
      </div>
    )
  }
}

export default LocationActivityListItem



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/location/LocationActivityListItem.tsx